import { Home, Users, Tag, ShoppingCart, CalendarDays, Settings, Sun } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
}

// Day-first tab order (Plan 12 program decision #2): Today, Plan, Shopping,
// Library — Library moved from first to last. Shared by the mobile
// BottomTabBar and the desktop AppSidebar/AppDrawer so all three nav
// surfaces stay consistent.
export const primaryNavItems: NavItem[] = [
  { id: "today", label: "Today", path: "/", icon: Sun },
  { id: "plan", label: "Plan", path: "/plan", icon: CalendarDays },
  { id: "shopping", label: "Shopping", path: "/shopping", icon: ShoppingCart },
  { id: "library", label: "Library", path: "/recipes", icon: Home },
];

export const settingsNavItems: NavItem[] = [
  { id: "household", label: "Household", path: "/settings/household", icon: Users },
  { id: "preferences", label: "Preferences", path: "/settings/preferences", icon: Settings },
  { id: "taxonomy", label: "Taxonomy", path: "/settings/taxonomy", icon: Tag },
];
